(function($)
{
    $.extend(true, orion, {
        api: {
            shippingAddresses: {}
        }
    });

    var
        api = orion.api.shippingAddresses,
        uri = '/api-customer-de/shipping-addresses';

    function read()
    {
        var
            promise = $.ajax(uri, {
                'method': 'GET'
            });

        return promise;
    }

    api.read = read;
})(jQuery);
